import { useNavigationData } from "../../../navigation-data";
import { MenuItem } from "./MenuItem/MenuItem";


export const Menu = ({platform, showMenu}) => {
  const navigationData = useNavigationData();
  return (
   <div>
      {navigationData.map((item, index) => (
        <MenuItem
          key={index}
          platform={platform}
          label={item.label}
          href={item.href}
          subItems={item.subItems}
        />
      ))}
    </div>
  );
};
